// extracted by mini-css-extract-plugin
module.exports = {"container":"AuthorBlock_container__6aG0j"};